import { NgModule, APP_INITIALIZER, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ComponentModule } from '../component/sharedComponent.module';
import { LoaderService } from '../services/loader.service';
import { LoaderInterceptorService } from '../services/loader-interceptor.service';
import { WindowRef } from '../services/window.service';
import { AuthService } from '../services/auth.service';


@NgModule({
    imports: [
        ComponentModule,
        HttpClientModule,

    ],
    exports: [
        ComponentModule,


    ],
    declarations: []
})

// Register here Global services
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                LoaderService, {
                    provide: HTTP_INTERCEPTORS,
                    useClass: LoaderInterceptorService,
                    multi: true
                },
                WindowRef,
                AuthService
            ],
        };
    }
}

